import router from '@/router'
import { instance, errorService } from '@/services/api'
import { templateAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'

export default {
  name: 'AddNewTemplate',
  props: {
    openPopup: Boolean,
    cloneTemplateData: Object,
    dropdownData: Object,
    type: String,
  },
  data() {
    return {
      form: {
        templateName: '',
        analysisTypeId: 0,
        structureProfileId: 0,
        buildingUseId: 0,
      },
      rules: {
        templateName: [
          {
            required: true,
            message: 'Please enter template name',
            trigger: 'blur',
          },
        ],
        analysisTypeId: [
          {
            required: true,
            message: 'Please select analysis type',
            trigger: 'change',
          },
        ],
        structureProfileId: [
          {
            required: true,
            message: 'Please select structure profile',
            trigger: 'change',
          },
        ],
        buildingUseId: [
          {
            required: true,
            message: 'Please select building use',
            trigger: 'change',
          },
        ],
      },
      visible: true,
      templateName: '',
      loaderCreate: false,
    }
  },
  mounted() {
    if (this.cloneTemplateData) {
      this.form.templateName = this.cloneTemplateData.templateName
      this.form.analysisTypeId = this.cloneTemplateData.analysisTypeId
      this.form.structureProfileId = this.cloneTemplateData.structureProfileId
      this.LoadBuildingUse(this.form.structureProfileId)
      this.form.buildingUseId = this.cloneTemplateData.buildingUseId
    }
  },
  methods: {
    handleOk() {
      this.loaderCreate = true
      instance
        .post(templateAPIs.template.addTemplate, this.form)
        .then(response => {
          const result = _.get(response.data, 'result', null)
          router.push({ path: `templates/${result.id}` })
          this.loaderCreate = false
        })
        .catch(error => {
          this.loaderCreate = false
          errorService(error)
        })
    },

    handleCancel() {
      this.$emit('closeCreatePopup', false)
    },

    LoadBuildingUse(value) {
      this.dropdownData['building_use'] = []
      this.form.buildingUseId = 0
      this.dropdownData['building_use'] = this.dropdownData[
        'temp_building_use'
      ].filter(i => i.structureProfileId === value)
    },

    cloneTemplate() {
      let apiDetails = this.cloneUnpublishTemplate()

      if (this.cloneTemplateData.status === 'Live') {
        apiDetails = this.clonePublishTemplate()
      }

      this.loaderCreate = true
      instance[apiDetails.method](apiDetails.url, apiDetails.request)
        .then(response => {
          this.loaderCreate = false
          if (this.cloneTemplateData.status === 'Design') {
            this.$notification.info({
              message: 'Clone Template',
              description: (
                <div>
                  <div>
                    Your request for clone template will be processed shortly.
                  </div>
                  <div>You will be notified once the request is completed</div>
                </div>
              ),
              duration: 200,
            })
          }
          this.$emit('closeCreatePopup', false, true)
        })
        .catch(error => {
          this.loaderCreate = false
          errorService(error)
        })
    },

    cloneUnpublishTemplate() {
      const request = {
        templateName: this.form.templateName,
        buildingUseId: this.form.buildingUseId,
      }

      return {
        url: templateAPIs.template.cloneTemplates(this.cloneTemplateData.id),
        request: request,
        method: 'put',
      }
    },

    clonePublishTemplate() {
      return {
        url: templateAPIs.template.clonePublishTemplate(
          this.cloneTemplateData.id,
        ),
        request: {},
        method: 'patch',
      }
    },
  },
}
